import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { CodeLayout, WhiteLayout, CodeColumnLayout, LayoutStep } from "netcompany-mdx-slide";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <WhiteLayout title={"The case study"} mdxType="WhiteLayout">
      <h3>{`Inheritance`}</h3>
      <ul>
        <li parentName="ul">
          <p parentName="li">{`reuse code or extend it for more specific use cases`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`implement the requirements in a maintainable way`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`inheritance is a tool we use upon finding opportunities for reuse, not to express real-world hierarchical similarities.`}</p>
        </li>
      </ul>
    </WhiteLayout>
    <hr></hr>
    <CodeColumnLayout title={"The case study"} subTitle={"Inheritance"} dynamicSizes={[[3, 1, 2], [2, 1, 3]]} mdxType="CodeColumnLayout">
  <LayoutStep mdxType="LayoutStep">
        <pre><code parentName="pre" {...{
            "className": "language-java",
            "metastring": "8,23:46 file=../src/main/java/com/netcompany/core/AbstractMenu.java showNumbers zoomIn=1.4,30 skipRows=9:21",
            "8,23:46": true,
            "file": "../src/main/java/com/netcompany/core/AbstractMenu.java",
            "showNumbers": true,
            "zoomIn": "1.4,30",
            "skipRows": "9:21"
          }}>{`package com.netcompany.core;

import java.util.ArrayList;
import java.util.List;
import java.util.Scanner;
import java.util.regex.Pattern;

public abstract class AbstractMenu implements Menu {
    private static final Pattern numericPattern = Pattern.compile("^\\\\d+$");
    protected ConsoleContext appCtx;
    protected List<MenuItem> menuItems;

    public AbstractMenu(ConsoleContext appCtx) {
        this.appCtx = appCtx;
        this.menuItems = new ArrayList<>();
    }

    @Override
    public List<MenuItem> getMenuItems() {
        return this.menuItems;
    }

    @Override
    public void launch() {
        String userChoise = null;
        int index;
        int userChoiseInt = 0;
        Scanner scanner = this.appCtx.getScanner();
        do {
            System.out.println(this.getMenuHeader());
            index = 1;
            for (MenuItem menuItem : this.getMenuItems()) {
                System.out.println(String.format("%d. %s", index, menuItem.getItemName()));
                index++;
            }
            System.out.println(String.format("0. %s", this.getBackItemName()));
            do {
                System.out.print(this.getSelectInstruction());
                userChoise = scanner.nextLine();
            } while (!this.checkUserChoise(userChoise));
            userChoiseInt = Integer.parseInt(userChoise);
            if (userChoiseInt != 0) {
                this.launchMenuItem(userChoiseInt - 1);
            }
        } while (userChoiseInt != 0);
    }

    protected String getSelectInstruction() {
        return "Enter your choise: ";
    }

    protected void launchMenuItem(int index) {
        this.getMenuItems()
                .get(index)
                .launch();
    }

    private boolean checkUserChoise(String userChoise) {
        if (!numericPattern.matcher(userChoise).find()) {
            System.out.println("Invalid choise: the choise must be integer and follow instruction above.");
            return false;
        }
        int userChoiseValue = Integer.parseInt(userChoise);
        if (userChoiseValue < 0 || userChoiseValue > this.getMenuItems().size()) {
            System.out.println(
                    String.format("Invalid choise: the choise must between 0 and %d", this.getMenuItems().size()));
            return false;
        }
        return true;
    }
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java",
            "metastring": "10:29 file=../src/main/java/com/netcompany/menu/MainMenu.java showNumbers",
            "10:29": true,
            "file": "../src/main/java/com/netcompany/menu/MainMenu.java",
            "showNumbers": true
          }}>{`package com.netcompany.menu;

import com.netcompany.core.AbstractMenu;
import com.netcompany.core.ConsoleContext;
import com.netcompany.menu.manageBalanceSheet.ManageBalanceSheetMenu;
import com.netcompany.menu.manageCourse.ManageCourseMenu;
import com.netcompany.menu.manageGrade.ManageGradeMenu;
import com.netcompany.menu.newBalanceSheetMenu.NewBalanceSheetMenu;

public class MainMenu extends AbstractMenu {
    public MainMenu(ConsoleContext appCtx) {
        super(appCtx);
        this.menuItems.add(new ManageCourseMenu(appCtx));
        this.menuItems.add(new ManageGradeMenu(appCtx));
        this.menuItems.add(new NewBalanceSheetMenu(appCtx));
        this.menuItems.add(new ManageBalanceSheetMenu(appCtx));
    }

    @Override
    public String getBackItemName() {
        return "Exit";
    }

    @Override
    public String getMenuHeader() {
        return "GPA Self-tracking application\\n" +
                "          - Powered by Dazzle\\n";
    }
}
`}</code></pre>
  </LayoutStep>
  <LayoutStep mdxType="LayoutStep">
        <pre><code parentName="pre" {...{
            "className": "language-java",
            "metastring": "10:29 file=../src/main/java/com/netcompany/menu/MainMenu.java showNumbers zoomIn=1.5,40",
            "10:29": true,
            "file": "../src/main/java/com/netcompany/menu/MainMenu.java",
            "showNumbers": true,
            "zoomIn": "1.5,40"
          }}>{`package com.netcompany.menu;

import com.netcompany.core.AbstractMenu;
import com.netcompany.core.ConsoleContext;
import com.netcompany.menu.manageBalanceSheet.ManageBalanceSheetMenu;
import com.netcompany.menu.manageCourse.ManageCourseMenu;
import com.netcompany.menu.manageGrade.ManageGradeMenu;
import com.netcompany.menu.newBalanceSheetMenu.NewBalanceSheetMenu;

public class MainMenu extends AbstractMenu {
    public MainMenu(ConsoleContext appCtx) {
        super(appCtx);
        this.menuItems.add(new ManageCourseMenu(appCtx));
        this.menuItems.add(new ManageGradeMenu(appCtx));
        this.menuItems.add(new NewBalanceSheetMenu(appCtx));
        this.menuItems.add(new ManageBalanceSheetMenu(appCtx));
    }

    @Override
    public String getBackItemName() {
        return "Exit";
    }

    @Override
    public String getMenuHeader() {
        return "GPA Self-tracking application\\n" +
                "          - Powered by Dazzle\\n";
    }
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java",
            "metastring": "11,12 file=../src/main/java/com/netcompany/NewMain.java showNumbers zoomIn=1.6,30",
            "11,12": true,
            "file": "../src/main/java/com/netcompany/NewMain.java",
            "showNumbers": true,
            "zoomIn": "1.6,30"
          }}>{`package com.netcompany;

import java.util.Scanner;

import com.netcompany.core.ConsoleContext;
import com.netcompany.menu.MainMenu;

public class NewMain {
    public static void main(String[] args) {
        ConsoleContext appContext = initiateApplicationContext();
        MainMenu application = new MainMenu(appContext);
        application.launch();
    }

    private static ConsoleContext initiateApplicationContext() {
        Scanner scanner = new Scanner(System.in);
        ConsoleContext appContext = new ConsoleContext(scanner);
        return appContext;
    }
}
`}</code></pre>
  </LayoutStep>
  <LayoutStep mdxType="LayoutStep">
        <pre><code parentName="pre" {...{
            "className": "language-java",
            "metastring": "5,38:41 file=../src/main/java/com/netcompany/entity/Course.java showNumbers zoomIn=1.6,40 skipRows=6:37",
            "5,38:41": true,
            "file": "../src/main/java/com/netcompany/entity/Course.java",
            "showNumbers": true,
            "zoomIn": "1.6,40",
            "skipRows": "6:37"
          }}>{`package com.netcompany.entity;

import com.netcompany.core.Entity;

public class Course implements Entity {
    private String code;
    private Float grade;

    public Course() {
    }

    public Course(String courseCode) {
        this.code = courseCode.toLowerCase();
        this.grade = null;
    }

    private Course(Course course) {
        this.code = course.getCode();
        this.grade = course.getGrade();
    }

    public Float getGrade() {
        return grade;
    }

    public void setGrade(Float grade) {
        this.grade = grade;
    }

    public String getCode() {
        return code;
    }

    public void setCode(String code) {
        this.code = code;
    }

    public void copy(Course course) {
        this.code = course.getCode();
        this.grade = course.getGrade();
    }

    public Course clone() {
        return new Course(this);
    }
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java",
            "metastring": "3,30:37 file=../src/main/java/com/netcompany/entity/BalancingCourse.java showNumbers zoomIn=1.7,40 skipRows=4:29",
            "3,30:37": true,
            "file": "../src/main/java/com/netcompany/entity/BalancingCourse.java",
            "showNumbers": true,
            "zoomIn": "1.7,40",
            "skipRows": "4:29"
          }}>{`package com.netcompany.entity;

public class BalancingCourse extends Course {
    private Float adjustedGrade;

    public BalancingCourse() {

    }

    public BalancingCourse(Course course) {
        this.setCode(course.getCode());
        this.setGrade(course.getGrade());
        this.adjustedGrade = null;
    }

    public BalancingCourse(String courseCode, Float grade, Float adjustedGrade) {
        super(courseCode);
        this.setGrade(grade);
        this.adjustedGrade = adjustedGrade;
    }

    public Float getAdjustedGrade() {
        return adjustedGrade;
    }

    public void setAdjustedGrade(float adjustedGrade) {
        this.adjustedGrade = adjustedGrade;
    }

    @Override
    public void copy(Course course) {
        super.copy(course);
        if (course instanceof BalancingCourse) {
            BalancingCourse balancingCourse = (BalancingCourse) course;
            this.adjustedGrade = balancingCourse.getAdjustedGrade();
        }
    }

    @Override
    public BalancingCourse clone() {
        BalancingCourse clonedCourse = new BalancingCourse();
        clonedCourse.copy(this);
        return clonedCourse;
    }

    public void resetAdjustedGrade() {
        this.adjustedGrade = this.getGrade();
    }
}
`}</code></pre>
  </LayoutStep>
    </CodeColumnLayout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      